/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendRecordReportedEmailQueryVariables = Types.Exact<{
  input: Types.SendRecordReportedEmailInput;
}>;


export type SendRecordReportedEmailQuery = { __typename?: 'Query', sendRecordReportedEmail: boolean };


export const SendRecordReportedEmailDocument = gql`
    query sendRecordReportedEmail($input: SendRecordReportedEmailInput!) {
  sendRecordReportedEmail(input: $input)
}
    `;
export function useSendRecordReportedEmailQuery(baseOptions: Apollo.QueryHookOptions<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables> & ({ variables: SendRecordReportedEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>(SendRecordReportedEmailDocument, options);
      }
export function useSendRecordReportedEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>(SendRecordReportedEmailDocument, options);
        }
// @ts-ignore
export function useSendRecordReportedEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>): Apollo.UseSuspenseQueryResult<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>;
export function useSendRecordReportedEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>): Apollo.UseSuspenseQueryResult<SendRecordReportedEmailQuery | undefined, SendRecordReportedEmailQueryVariables>;
export function useSendRecordReportedEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>(SendRecordReportedEmailDocument, options);
        }
export type SendRecordReportedEmailQueryHookResult = ReturnType<typeof useSendRecordReportedEmailQuery>;
export type SendRecordReportedEmailLazyQueryHookResult = ReturnType<typeof useSendRecordReportedEmailLazyQuery>;
export type SendRecordReportedEmailSuspenseQueryHookResult = ReturnType<typeof useSendRecordReportedEmailSuspenseQuery>;
export type SendRecordReportedEmailQueryResult = Apollo.QueryResult<SendRecordReportedEmailQuery, SendRecordReportedEmailQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useSendRecordReportedEmail = withQueryResponseHandler(useSendRecordReportedEmailQuery);
